import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { IFilter, IResponsible, ResponsibleType } from '@shared/interfaces';
import { MatPaginator } from '@angular/material/paginator';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ResponsibleService } from '@shared/services/responsible.service';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
    selector: 'reporting-tool-responsible-selection',
    templateUrl: './reporting-tool-responsible-selection.component.html',
    styleUrls: ['./reporting-tool-responsible-selection.component.scss'],
    standalone: false
})
export class ReportingToolResponsibleSelectionComponent implements OnInit {
    dataSource: MatTableDataSource<IResponsible> = new MatTableDataSource<IResponsible>();
    value: IResponsible[] = [];
    inputText: string;

    displayedColumns = ['selected', 'title', 'code', 'responsible', 'specialists'];
    filters: IFilter[] = [
        { placeholder: 'generic.filter.all', selected: true, value: ResponsibleType.all },
        { placeholder: 'generic.filter.sag', selected: false, value: ResponsibleType.sag },
        { placeholder: 'generic.filter.rc', selected: false, value: ResponsibleType.rc }
    ];

    @ViewChild(MatPaginator) paginator: MatPaginator;

    constructor(
        public dialogRef: MatDialogRef<ReportingToolResponsibleSelectionComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { multiple: boolean; data: IResponsible[] },
        private responsibleService: ResponsibleService
    ) {}

    async ngOnInit() {
        return this.loadAll();
    }

    async loadAll() {
        const type = this.filters.find(e => e.selected).value;
        try {
            const data = await this.responsibleService.getAll({ type });
            const items = data.items;
            if (this.data.data) {
                this.value = Object.assign([], this.data.data);
                items.forEach(e => (e.selected = this.data.data.some(a => a.id === e.id)));
            }
            this.dataSource.data = items;
            this.dataSource.paginator = this.paginator;
        } catch (e) {
            console.error(e);
        }
    }

    applyFilter() {
        this.dataSource.filter = this.inputText;
    }

    closeDialog() {
        this.dialogRef.close(
            this.value.map(e => ({
                id: e.id,
                title: e.orgDescription,
                code: e.orgCode,
                responsibleType: e.responsibleType,
                responsible: e.responsible,
                specialists: e.specialists
            }))
        );
    }

    changeSelected(element: IResponsible, event: MatCheckboxChange) {
        if (this.data.multiple) {
            if (!element.selected && !event.checked) {
                this.value = this.value.filter(e => e.id !== element.id);
            } else if (element.selected && event.checked) {
                element.selected = true;
                this.value.push(element);
            }
        } else {
            if (this.value[0]) {
                this.value[0].selected = false;
            }
            element.selected = event.checked;
            this.value = element.selected ? [element] : [];
        }
    }

    getUser(item: IResponsible, type: string): string {
        return item[type] ? item[type].map(e => e.fullName).join(', ') : null;
    }
}
